async function getConfig2() {
  var request = await fetch(`${process.env.PUBLIC_URL}/config.json`,
    {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    })
    .then((response) => {
      return response.json();
    });

  return request;
}

const edgar2 = () => {
  return getConfig2().then((response) => {
    return response;
  })
}

export default edgar2;